// Отображение меню в зависимости от скрола
// Поиск фрейма с меню
let menuFrame = document.querySelector(".header__scroll")
window.onscroll = function displayingMenu() {
    if (window.pageYOffset > 200) {
        // Показывает меню, если пользователь проскролил больше установленного значения
        menuFrame.classList.add('scroll');
    } else {
        // скрывает меню, если пользователь проскролил меньше установленного значения
        menuFrame.classList.remove('scroll');
    }
};

// Показ полного списка меню
// Поиск кнопки бургера
let openMenuBtn = document.querySelector(".header__menu_open");
// Содержимое меню
let menuBody = document.querySelector(".header__nav_body");
// Все ссылки в меню
let menuItems = document.querySelectorAll('.nav__link');

// Раскрывает меню если было нажатие на кнопку openMenuBtn
openMenuBtn.onclick = function() {
    this.classList.toggle('is-open');
    menuBody.classList.toggle('is-open');
};

// Скрываем меню, если был клик на ссылку
menuItems.forEach((menuItem) =>
    menuItem.addEventListener(`click`, (event) => {
        openMenuBtn.classList.toggle('is-open');
        menuBody.classList.toggle('is-open');
    }))

// Плавная прокрутка до якоря
// Получение всех якорей
const anchors = document.querySelectorAll('a[href*="#"]')

// Перебираем полученные якоря
anchors.forEach((anchor) =>  {
    anchor.addEventListener('click', function (e) {
        e.preventDefault()

        const blockID = anchor.getAttribute('href').substr(1)
        document.getElementById(blockID).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        })
    })
})